module.exports = __webpack_public_path__ + "static/media/3.a38c5c88.jpg";